export default __webpack_public_path__ + "static/media/diabetology.f75e0dde.jpg";